<template>
    <div>
      <van-nav-bar
        title="完善资料"
        left-text=""
        left-arrow
        @click-left="$router.push('/member/members')"
      />
      <van-cell-group>
        <van-cell id="custom-arrow" title="昵称" is-link :value="name" to='information/nick_name' />
        <van-cell id="custom-arrow" title="实名认证" :is-link="realStatus" :value="real" @click="openReal" />
        <van-cell id="custom-arrow" title="银行卡" :is-link="bankStatus" :value="bank" @click="openBank"  />
        <van-cell id="custom-arrow" title="提款地址" is-link :value="withdraw_address" @click="openWithdrawAddress"  />
        <van-cell id="custom-arrow" title="手机" is-link :value="phone"  to="information/bink_phone" />
        <van-cell id="custom-arrow" title="邮箱" is-link :value="email"  to="information/bind_email" />
      </van-cell-group>
      <van-cell-group title="密码">
        <van-cell id="custom-arrow" title="登录密码" is-link value="已设置" to="information/login_pass" />
        <van-cell id="custom-arrow" title="提款密码" is-link :value="withdrawal" to="information/withdrawal_pass" />
      </van-cell-group>
    </div>
</template>

<script>
    export default {
      name: "Information",
      data(){
        return{
          name:'未设置',
          real:'未实名',
          realStatus:false,
          bank:'未绑定',
          phone:'',
          email:'未设置',
          withdrawal:'未设置',
          bankStatus:true,
          withdraw_address :'未实名' ,
        }
      },
      methods:{
        isLogin(){
          let that = this;
          if (!that.$store.state.loginType){
            that.$router.push('/login')
          }
        },
        getConfig(){
          let that = this;
          that
            .$http({
              url: "/",
              method: "post",
              data: {
                nozzle: "user_info",
                token: sessionStorage.getItem("token")
              }
            })
            .then(function(res) {
              let resData = res.data;
              // console.log(resData);
              if (resData.code === 1) {
                resData.data.name === '' ? that.name = '未设置' : that.name = resData.data.name;
                if (resData.data.real === null){
                  that.real = '未实名';
                  that.realStatus = true;
                }else {
                  that.real = resData.data.real;
                  that.realStatus = false;
                }
                if (resData.data.bank === 0){
                  that.bank = '未绑定';
                  //that.bankStatus = true;
                }else {
                  that.bank = '已绑定银行卡';
                  //that.bankStatus = false;
                }
                if (resData.data.withdraw_address === null){
                  that.withdraw_address = '未实名';
                }else {
                  that.withdraw_address = resData.data.withdraw_address;
                }
                
                that.phone = resData.data.phone;

                that.$store.commit("changePhone", resData.data.phone1);
                resData.data.withdrawal === 0 ? that.withdrawal = '未设置' : that.withdrawal = '已设置';
                resData.data.email === 0 ? that.email = '未设置' : that.email = resData.data.email;;

              } else if (resData.code === 0 || resData.code === -1) {
                that.$toast.fail(resData.msg);
              }
            });
        },
        openReal(){
          let that = this;
          if (that.realStatus){
            that.$router.push('information/real_name');
          }
        },
        openBank(){
          let that = this;
          // if (that.bankStatus){
          //   that.$router.push('information/bind_bank');
          // }
          that.$router.push('information/bind_bank');
        },
        openWithdrawAddress(){
          let that = this;
          that.$router.push('information/withdrawal_address');
        }
      },
      mounted:function () {
        let that = this;
        that.isLogin();
        that.getConfig();
      }
    }
</script>

<style scoped>

</style>

<style>
  #custom-arrow .van-cell__right-icon {
    color: black !important; 
    font-weight: bold;
  }
  #custom-arrow .van-cell__title {
    color: black !important; 
  }

</style>



// WEBPACK FOOTER //
// src/components/Information.vue